import { ThemeApp } from 'themes/types/themeApp/theme.types';
import { themeUi } from '../../themeUi/themeUi';

export const accountSettings: ThemeApp['appComponents']['accountSettings'] = {
  account: {
    shared: {
      card: {
        card: {
          backgroundColor: themeUi.semantic.color.background.secondary950,
          boxShadow: themeUi.core.shadow.shadow4
        },

        cardHeader: {
          color: themeUi.semantic.color.text.secondary50,
          borderBottom: themeUi.semantic.color.border.secondary800
        },

        cardContent: {
          backgroundColor: themeUi.semantic.color.background.secondary990
        }
      },

      divider: {
        divider: {
          darkBorderBottom: themeUi.semantic.color.border.neutral500,
          borderBottom: themeUi.semantic.color.border.secondary800
        }
      },

      sectionItem: {
        label: {
          color: themeUi.semantic.color.text.secondary50
        }
      },
      businessSection: {
        accountAddressCard: {
          address: {
            color: themeUi.semantic.color.text.secondary50
          }
        }
      }
    }
  },

  cloudAccounts: {
    addEditModal: {
      form: {
        cloudAccAddEditForm: {
          leftBox: {
            borderRight: themeUi.semantic.color.border.secondary800
          },
          boxTitle: {
            color: themeUi.semantic.color.text.secondary50
          }
        }
      }
    },

    cloudAccountsEmptyResults: {
      readMoreBtn: {
        color: themeUi.semantic.color.text.primary600
      }
    },

    components: {
      tableCells: {
        cells: {
          svgIcon: {
            color: themeUi.semantic.color.icon.primary600
          }
        }
      }
    }
  }
};
